export const SET_WINDOW_SIZE = 'SET_WINDOW_SIZE';
export const UPDATE_DATA = 'UPDATE_DATA';
export const SET_INFOGRAPHIC = 'SET_INFOGRAPHIC';

export function setWindowSize(size) {
  return ({
    type: SET_WINDOW_SIZE,
    payload: size,
  });
}

export function updateData(data) {
  return ({
    type: UPDATE_DATA,
    payload: data,
  });
}

export function setInfographic(g) {
  return ({
    type: SET_INFOGRAPHIC,
    payload: g,
  });
}



// WEBPACK FOOTER //
// ./src/store/actions.js